import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axiosInstance from 'axiosInstance';

const defaultCounts = { stockBreached: 0, questionsUnanswered: 0, messagesUnread: 0 };

const NavCountsContext = createContext(defaultCounts);

export const NavCountsProvider = ({ children }) => {
  const [counts, setCounts] = useState(defaultCounts);

  const fetchCounts = useCallback(async () => {
    try {
      const response = await axiosInstance.get('notifications/nav-counts');
      setCounts(response.data);
    } catch {
      // silent — badge counts are non-critical
    }
  }, []);

  useEffect(() => {
    fetchCounts();
    const id = setInterval(fetchCounts, 60000);
    return () => clearInterval(id);
  }, [fetchCounts]);

  return (
    <NavCountsContext.Provider value={counts}>
      {children}
    </NavCountsContext.Provider>
  );
};

export const useNavCounts = () => useContext(NavCountsContext);

export default NavCountsContext;
